export default {
	namespaced: true,

	state: {
		cognitoUser: null,
	},

	getters: {
		cognitoUser: state => state.cognitoUser,
		userType: (_, getters) => {
			if (!getters.cognitoUser) return null;
			return getters.cognitoUser;
		},
	},
};
